import { BackspaceIcon } from "@heroicons/react/24/outline";

import classNames from "../../utils/classNames";
import { applyKeypadKey, KeypadKey } from "../../utils/till/keypad";

interface TillNumericKeypadProps {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}

const KEYS: KeypadKey[][] = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  [".", "0", "00"],
];

/** Touch keypad for entering a money amount. */
export default function TillNumericKeypad({ value, onChange, disabled }: TillNumericKeypadProps) {
  const press = (key: KeypadKey) => onChange(applyKeypadKey(value, key));

  const keyClasses = "h-14 rounded-lg border border-gray-300 bg-white text-2xl font-medium text-gray-900 shadow-sm active:bg-gray-100 disabled:opacity-50";

  return (
    <div className="grid grid-cols-4 gap-2" role="group" aria-label="Amount keypad">
      {KEYS.map((row, r) => (
        <div key={r} className="contents">
          {row.map((key) => (
            <button key={key} type="button" disabled={disabled} onClick={() => press(key)} className={keyClasses}>
              {key}
            </button>
          ))}
          {r === 0 ? (
            <button type="button" disabled={disabled} onClick={() => press("back")} className={classNames(keyClasses, "row-span-2 flex items-center justify-center text-gray-600")} aria-label="Backspace">
              <BackspaceIcon className="h-8 w-8" />
            </button>
          ) : null}
          {r === 2 ? (
            <button type="button" disabled={disabled} onClick={() => press("clear")} className={classNames(keyClasses, "row-span-2 text-base text-red-600")}>
              Clear
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
